import React from 'react';

import { StyleSheet } from 'react-native';

import { withTypography } from 'components/ui';
import { Box, BoxProps } from 'components/ui/box';
import { layout, primitive, spacing } from 'styles/constants';

export const DeliveryCardContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.deliveryCardContainer, style],
  });

export const CardHeading = withTypography({
  variant: 'headerFour',
  color: primitive.$bbqBrown,
  fontSize: 'xl',
  lineHeight: 'sm',
  m: '$0',
  style: { textTransform: 'capitalize' },
});

export const CardHeadingContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    focusable: true,
    ...props,
    style: [styles.cardHeadingContainer, style],
  });

export const CardText = withTypography({ variant: 'copyOne' });

const styles = StyleSheet.create({
  cardHeadingContainer: {
    padding: spacing.$4,
  },
  deliveryCardContainer: {
    width: layout.full,
  },
});
